import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import img from '../../assets/accept.png'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 280,
    bgcolor: 'background.paper',
    border: 'none',
    outline: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
};

export default function SuccessModal() {
    const [open, setOpen] = React.useState(true);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            {/* <Button onClick={handleOpen}>Open modal</Button> */}
            <div className='row'>
                <div className='col-md-5 col-12'>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                        className='border-0'
                    >
                        <Fade in={open} className='border-0'>
                            <Box sx={style} className='d-flex justify-content-center flex-column align-items-center border-0 rounded'>
                                <img src={img} className='img-check mb-4' />
                                <Typography id="transition-modal-title" variant="h5" component="h2" className='text-center'>
                                    Payment Successfully Completed
                                </Typography>
                            </Box>
                        </Fade>
                    </Modal>
                </div>
            </div>
        </div >
    );
}
